// Bridges the AIFC trace ID from the create modal to the feedback banner on the
// created page. Keyed by content ID so a trace ID is never used for feedback on a
// different page (the banner can persist after the user navigates away).
const traceIdByContentId = new Map<string, string>();

export const setTraceIdForContent = (
	contentId: string | undefined,
	traceId: string | undefined,
): void => {
	if (contentId && traceId) {
		traceIdByContentId.set(contentId, traceId);
	}
};

export const getTraceIdForContent = (contentId: string | undefined): string | undefined =>
	contentId ? traceIdByContentId.get(contentId) : undefined;

export const clearTraceIdForContent = (contentId: string | undefined): void => {
	if (contentId) {
		traceIdByContentId.delete(contentId);
	}
};
